// dashboardactions.js
export const FETCH_TICKETS_COUNTS_REQUEST = 'FETCH_TICKETS_COUNTS_REQUEST';
export const FETCH_STATISTICS_REPORT_REQUEST = 'FETCH_STATISTICS_REPORT_REQUEST';
export const FETCH_COMPLETE_REPORT_REQUEST = 'FETCH_COMPLETE_REPORT_REQUEST';
export const FETCH_REPORT_HFC_REQUEST = 'FETCH_REPORT_HFC_REQUEST';
export const FETCH_REPORT_GPON_REQUEST = 'FETCH_REPORT_GPON_REQUEST';
export const FETCH_REPORT_COPPER_REQUEST = 'FETCH_REPORT_COPPER_REQUEST';

export const FETCH_TICKETS_COUNTS_SUCCESS = 'FETCH_TICKETS_COUNTS_SUCCESS';
export const FETCH_STATISTICS_REPORT_SUCCESS = 'FETCH_STATISTICS_REPORT_SUCCESS';
export const FETCH_COMPLETE_REPORT_SUCCESS = 'FETCH_COMPLETE_REPORT_SUCCESS';
export const FETCH_REPORT_HFC_SUCCESS = 'FETCH_REPORT_HFC_SUCCESS';
export const FETCH_REPORT_GPON_SUCCESS = 'FETCH_REPORT_GPON_SUCCESS';
export const FETCH_REPORT_COPPER_SUCCESS = 'FETCH_REPORT_COPPER_SUCCESS';

export const FETCH_TICKETS_COUNTS_FAILURE = 'FETCH_TICKETS_COUNTS_FAILURE';
export const FETCH_STATISTICS_REPORT_FAILURE = 'FETCH_STATISTICS_REPORT_FAILURE';
export const FETCH_COMPLETE_REPORT_FAILURE = 'FETCH_COMPLETE_REPORT_FAILURE';
export const FETCH_REPORT_HFC_FAILURE = 'FETCH_REPORT_HFC_FAILURE';
export const FETCH_REPORT_GPON_FAILURE = 'FETCH_REPORT_GPON_FAILURE';
export const FETCH_REPORT_COPPER_FAILURE = 'FETCH_REPORT_COPPER_FAILURE';

export const fetchTicketCountsRequest = (data) => ({ type: FETCH_TICKETS_COUNTS_REQUEST,payload: data  });
export const fetchStatisticsReportRequest = (data) => ({ type: FETCH_STATISTICS_REPORT_REQUEST, payload: data, payload: data });
export const fetchCompleteReportRequest = (data) => ({ type: FETCH_COMPLETE_REPORT_REQUEST, payload: data });
export const fetchReportHfcRequest = (data) => ({ type: FETCH_REPORT_HFC_REQUEST, payload: data });
export const fetchReportGponRequest = (data) => ({ type: FETCH_REPORT_GPON_REQUEST, payload: data });
export const fetchReportCopperRequest = (data) => ({ type: FETCH_REPORT_COPPER_REQUEST, payload: data });

export const fetchTicketCountsSuccess = (data) => ({ type: FETCH_TICKETS_COUNTS_SUCCESS, payload: data });
export const fetchStatisticsReportSuccess = (data) => ({ type: FETCH_STATISTICS_REPORT_SUCCESS, payload: data });
export const fetchCompleteReportSuccess = (data) => ({ type: FETCH_COMPLETE_REPORT_SUCCESS, payload: data });
export const fetchReportHfcSuccess = (data) => ({ type: FETCH_REPORT_HFC_SUCCESS, payload: data });
export const fetchReportGponSuccess = (data) => ({ type: FETCH_REPORT_GPON_SUCCESS, payload: data });
export const fetchReportCopperSuccess = (data) => ({ type: FETCH_REPORT_COPPER_SUCCESS, payload: data });

export const fetchTicketCountsFailure = (error) => ({ type: FETCH_TICKETS_COUNTS_FAILURE, payload: error });
export const fetchStatisticsReportFailure = (error) => ({ type: FETCH_STATISTICS_REPORT_FAILURE, payload: error });
export const fetchCompleteReportFailure = (error) => ({ type: FETCH_COMPLETE_REPORT_FAILURE, payload: error });
export const fetchReportHfcFailure = (error) => ({ type: FETCH_REPORT_HFC_FAILURE, payload: error });
export const fetchReportGponFailure = (error) => ({ type: FETCH_REPORT_GPON_FAILURE, payload: error });
export const fetchReportCopperFailure = (error) => ({ type: FETCH_REPORT_COPPER_FAILURE, payload: error });